/**
 * @author EdenCha <eden@nurigo.net>
 */
import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import TextField from '@material-ui/core/TextField'

const styles = theme => ({
  root: {}
})

const SearchTextField = ({ classes, proxy, ...props }) => {
  const {
    type,
    label,
    value,
    itemIndex,
    disableEnter = false,
    onChangeSearchValue,
    onSubmitSearch
  } = props
  return (
    <TextField
      label={label}
      type={type}
      value={value}
      fullWidth
      onKeyUp={e => {
        if (e.keyCode === 13 && disableEnter === false) {
          onChangeSearchValue(itemIndex, e.target.value)
          onSubmitSearch(e)
        }
      }}
      onChange={e => {
        onChangeSearchValue(itemIndex, e.target.value)
      }}
      InputLabelProps={{
        shrink: true
      }}
    />
  )
}
export default withStyles(styles)(SearchTextField)
